import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import axios from "../../utils/axiosInstance";
import { useEffect, useState } from "react";
import {
  getSetpoints,
  requestClearFault,
  requestSetpoints,
  WELLPRO_REGISTERS,
} from "../../utils/controlConfig";
import { ProgressDialog } from "../plungerPage/progressPopup";
import { toast } from "react-toastify";
import { getUIDescription } from "../SiteAdmin/customerGroupDetails/AssigningCustomerGroupDevice";

export const WellProCompressorDischargePIDCard = ({
  unitId,
  data,
  fetchData,
}) => {
  const [form, setForm] = useState({
    dischargePSIActual: "",
    dischargePidSP: "",
    dischargePidDeadband: "",
  });
  const [progressOpen, setProgressOpen] = useState(false);
  const [progressSuccess, setProgressSuccess] = useState(false);
  const [progressError, setProgressError] = useState("");

    const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const fetchWellProCompressorDischarge = async () => {
    if (!unitId || !data) return;
    try {
        setForm({
          dischargePSIActual: parseFloat(data._40108) / 10 ?? "",
          dischargePidSP: parseFloat(data._40280) / 10 ?? "",
          dischargePidDeadband: parseFloat(data._40281) / 10 ?? "",
        });
    } catch (err) {
      console.error("Failed to get wellPro compressor discharge:", err);
    }
  };

  const validateFields = () => {
    const emptyFields = Object.entries(form).filter(
      ([key, value]) => value === "" || value === null || value === undefined,
    );
    return emptyFields.map(([key]) => key);
  };

  const updateWellProCompressorDischarge = async () => {
    const missingFields = validateFields();
    if (missingFields.length > 0) {
      toast.error(
        `Please fill in the following fields: ${missingFields.join(", ")}`,
        {
          autoClose: 5000,
        },
      );
      return;
    }
    try {
      const initialResp = await axios.post(
        `${process.env.REACT_APP_API_GATEAWAY}/iot/device_get_by_register/${unitId}`,
        WELLPRO_REGISTERS,
      );
      const baseline = {
        time: Number(initialResp.data.data?.time || 0),
        response: initialResp.data.data?.response || {},
      };
      console.log("Initial baseline time", baseline);
      const sp = (label) => parseFloat(form[label]) || 0;
      let cmd = "S";
      cmd += `,${279},${sp("dischargePidSP") * 10}`;
      cmd += `,${280},${sp("dischargePidDeadband") * 10}`;
      setProgressOpen(true);
      setProgressSuccess(false);
      await axios.post(
        `${process.env.REACT_APP_API_GATEAWAY}/iot/control/precision/cmd`,
        {
          unitId,
          cmd,
          UI_Description: `${getUIDescription()}\n Send Command to the controller \nCmd: ${cmd}`,
        },
        {
          headers: {
            id: "anything",
            "Content-Type": "application/json",
          },
        },
      );
      console.log("Sending command:", cmd);
      setTimeout(() => {
        requestSetpoints(
          unitId,
          "P,279,1,280,1",
          baseline,
          setProgressSuccess,
          setProgressError,
          setProgressOpen,
        );
      }, 100);
    } catch (error) {
      console.log("Error to update wellPro compressor discharge", error);
    }
  };

  useEffect(() => {
    if (unitId) {
      fetchWellProCompressorDischarge();
    }
  }, []);

  return (
    <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4 }}>
      <Paper sx={{ p: 2, bgcolor: "#1e293b", borderRadius: 2, mb: 2 }}>
        <Typography sx={{ mb: 2, fontSize: 14 }}>
          Compressor Discharge PID SP's
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          <Typography sx={{ fontSize: 13 }}>Discharge PSI Actual</Typography>
          <Typography sx={{ fontSize: 13 }}>
            {form.dischargePSIActual}
          </Typography>
        </Box>

        <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
          <Button
            variant="contained"
            color="primary"
            sx={{ fontSize: { xs: "10px", sm: "11px", md: "12px" } }}
            fullWidth
            onClick={() =>
              getSetpoints(
                unitId,
                "P,279,1,280,1",
                setProgressSuccess,
                setProgressError,
                setProgressOpen,
              )
            }
          >
            Get Setpoints
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{ fontSize: { xs: "10px", sm: "11px", md: "12px" } }}
            fullWidth
            onClick={updateWellProCompressorDischarge}
          >
            Submit
          </Button>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography sx={{ fontSize: 13 }}>Discharge PID SP</Typography>
            <TextField
              fullWidth
              size="small"
              value={form.dischargePidSP}
              onChange={(e) => handleChange("dischargePidSP", e.target.value)}
              sx={{
                mb: 1,
                input: {
                  color: "#fff",
                  backgroundColor: "#1f2937",
                  fontSize: 13,
                },
              }}
            />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography sx={{ fontSize: 13 }}>
              Discharge PID DB
            </Typography>
            <TextField
              fullWidth
              size="small"
              value={form.dischargePidDeadband}
              onChange={(e) =>
                handleChange("dischargePidDeadband", e.target.value)
              }
              sx={{
                mb: 1,
                input: {
                  color: "#fff",
                  backgroundColor: "#1f2937",
                  fontSize: 13,
                },
              }}
            />
          </Box>
        </Box>
      </Paper>

      <ProgressDialog
        open={progressOpen}
        isSuccess={progressSuccess}
        errorMessage={progressError}
        onClose={() => {
          setProgressOpen(false);
          setProgressError("");
        }}
        onRefresh={async () => {
          setProgressOpen(false);
          setProgressError("");
          await fetchData();
        }}
        loadingMessage="Check Device Response. Operation in-progress ..."
        successMessage="Successfully updated!"
      />
    </Grid>
  );
};
